import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import sessionStorage from "redux-persist/lib/storage/session";

import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import UISlice from "@/redux/slices/ui";
import PlanSlice from "@/redux/slices/plan";
import AuthSlice from "@/redux/slices/auth";
import TenantSlice from "@/redux/slices/tenant";

const persistUIConfig = {
  key: "eltonfagundes-checkout-ui",
  storage: storage,
};

const persistPlansConfig = {
  key: "eltonfagundes-checkout-plans",
  storage: storage,
};

const persistAuthConfig = {
  key: "eltonfagundes-checkout-auth",
  storage: sessionStorage,
};

const persistedUIReducer = persistReducer(persistUIConfig, UISlice);
const persistedPlanReducer = persistReducer(
  persistPlansConfig,
  PlanSlice
);
const persistedAuthReducer = persistReducer(
  persistAuthConfig,
  AuthSlice
);

const store = configureStore({
  reducer: {
    ui: persistedUIReducer,
    plan: persistedPlanReducer,
    auth: persistedAuthReducer,
    tenant: TenantSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;

export const Persistor = persistStore(store);
